<ion-header [translucent]="true">
  <ion-toolbar class="ion-text-center">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>E-Support - {{metricId}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeModal()"><ion-icon name="close"></ion-icon></ion-button>
      <div class="college-logo-container" *ngIf="showCollegeLogo && collegeLogo">
        <img [src]="collegeLogo" alt="College Logo" class="college-logo-image" />
      </div>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="segment-label">
    <div class="container" *ngIf="selected">
        <div class="row bg-info text-white">
            <div class="col"><strong>Institution:</strong> {{institution}}</div>
        </div>
        <div class="row bg-brand-light-gr">
            <div class="col"><strong> Metric No:</strong>  {{metricId}}</div>
            <div class="col"><strong> Metric Type:</strong>  QlM</div>
            <div class="col"><strong> Weightage:</strong>  {{selected.weight }}</div>
        </div>
        <!-- Description -->
        <div class="row bg-brand-light-info">
            <div class="col">
                <strong>Description:</strong>
                <div [innerHTML]="selected.desc" class="description-content"></div>
            </div>
        </div>
        <!-- Specific Instructions -->
        <div class="row bg-brand-light-warning">
            <div class="col-12">
                <strong>Instructions:</strong>
                <ol *ngIf="selected.instructions && selected.instructions.length > 0 && !(selected.instructions.length === 1 && (selected.instructions[0] === '--' || selected.instructions[0] === '-'))">
                    <li *ngFor="let list of selected.instructions" [innerHTML]="list"></li>
                </ol>
                <div *ngIf="!selected.instructions || selected.instructions.length === 0 || (selected.instructions.length === 1 && (selected.instructions[0] === '--' || selected.instructions[0] === '-'))" class="not-applicable">
                    Not applicable
                </div>
            </div>
        </div>
        <!-- File Description -->
        <div class="row bg-brand-light-gr">
            <div class="col-12">
                <strong>File Description:</strong>
                <ol *ngIf="selected.fileDescription && selected.fileDescription.length > 0 && !(selected.fileDescription.length === 1 && (selected.fileDescription[0] === '--' || selected.fileDescription[0] === '-'))">
                    <li *ngFor="let list of selected.fileDescription" [innerHTML]="list"></li>
                </ol>
                <div *ngIf="!selected.fileDescription || selected.fileDescription.length === 0 || (selected.fileDescription.length === 1 && (selected.fileDescription[0] === '--' || selected.fileDescription[0] === '-'))" class="not-applicable">
                    Not applicable
                </div>
            </div>
        </div>

    </div>

</ion-content>

